import Vue from "vue";
import Vuex from "vuex";
import { once } from "lodash-es";

Vue.use(Vuex);

declare global {
  interface Window {
    zE: any;
  }
}

const bindOnce = once(() => {
  window.zE("webWidget:on", "close", () => {
    window.zE("webWidget", "hide");
    store.dispatch("toggleZendesk", false);
  });
});

const TYPES = {
  UPDATE_CLIENT_INFO: "UPDATE_CLIENT_INFO",
  SET_TOKEN: "SET_TOKEN",
  SET_CURRENCIES: "SET_CURRENCIES",
  TOGGLE_ZENDESK: "TOGGLE_ZENDESK"
};

const store = new Vuex.Store({
  state: {
    token: "",
    currencies: [],
    clientInfo: {
      uiSize: "default",
      timestamp: "",
      signature: "",
      userType: "",
      appId: "",
      appUid: "",
      appUrl: "",
      appKey: "",
      code: ""
    },
    isZendeskOpened: false
  },
  mutations: {
    [TYPES.UPDATE_CLIENT_INFO](state, value) {
      state.clientInfo = { ...state.clientInfo, ...value };
    },
    [TYPES.SET_TOKEN](state, value) {
      state.token = value;
    },
    [TYPES.SET_CURRENCIES](state, value) {
      state.currencies = value;
    },
    [TYPES.TOGGLE_ZENDESK](state, value) {
      const open = value ?? !state.isZendeskOpened;
      if (open === state.isZendeskOpened) {
        return;
      } else if (open) {
        window.zE("webWidget", "open");
        window.zE("webWidget", "show");
      } else {
        window.zE("webWidget", "hide");
        window.zE("webWidget", "close");
      }
      state.isZendeskOpened = open;
    }
  },
  actions: {
    updateClientInfo({ commit }, value) {
      commit(TYPES.UPDATE_CLIENT_INFO, value);
    },
    setToken({ commit }, value) {
      commit(TYPES.SET_TOKEN, value);
    },
    setCurrencies({ commit }, value) {
      commit(TYPES.SET_CURRENCIES, value);
    },
    toggleZendesk({ commit }, value) {
      if (!window.zE) {
        return;
      } else {
        bindOnce();
        commit(TYPES.TOGGLE_ZENDESK, value);
      }
    }
  }
});

export default store;
